import type { AsyncSequence } from "../types/AsyncSequence"

/**
 * Concatenates multiple async sequences into a single async generator.
 * Values are yielded in order from each sequence.
 *
 * @param arrays - One or more async sequences to concatenate
 * @returns An async generator that yields all values from all sequences in order
 *
 * @example
 * ```ts
 * import { ArrayToIterable } from "@pdfking/tfunc"
 *
 * async function* gen1() {
 *   yield 1;
 *   yield 2;
 * }
 *
 * async function* gen2() {
 *   yield 3;
 *   yield 4;
 * }
 *
 * for await (const value of ArrayToIterable(gen1(), gen2())) {
 *   console.log(value); // 1, 2, 3, 4
 * }
 * ```
 */
export const ArrayToIterable = async function* <T>(
  ...arrays: AsyncSequence<T>[]
): AsyncGenerator<T> {
  for (const array of arrays) {
    yield* array
  }
}
